import { DatePipe, NgIf, NgFor, NgClass, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren, AfterViewInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { PolicyCriteria, PolicyCriteriaCommonApiLists } from 'src/app/models/interface/cam.interface';
import { PolicyCriteriaTypes } from 'src/app/models/interface/FlightSearch/CommanModel.interface';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CookiesService } from 'src/app/services/cookies.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { PolicyManagementService } from 'src/app/services/dataLayer/CAM/policy-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { NgTemplateRefDirective } from 'src/app/shared/directive/ng-template-ref.directive';
import { PolicyContentService } from '../../services/policy-content.service';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { NgSelectComponent, NgOptionComponent, NgOptionTemplateDirective } from '@ng-select/ng-select';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgTemplateRefDirective as NgTemplateRefDirective_1 } from '../../../../shared/directive/ng-template-ref.directive';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { ExpiryDataCalendarComponent } from '../../../passenger/components/expiry-data-calendar/expiry-data-calendar.component';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';

@Component({
    selector: 'app-policy-criteria',
    templateUrl: './policy-criteria.component.html',
    styleUrls: ['./policy-criteria.component.scss'],
    imports: [ReactiveFormsModule, FormsModule, MatCheckbox, NgIf, MatError, NgFor, NgSelectComponent, NgOptionComponent, NgClass, MatIcon, MatFormField, MatLabel, MatInput, MatSlideToggle, MatButton, MatProgressSpinner, NgTemplateRefDirective_1, MatRadioGroup, MatRadioButton, NgSwitch, NgSwitchCase, AutoBlurSelectDirective, NgOptionTemplateDirective, MatSuffix, ExpiryDataCalendarComponent]
})
export class PolicyCriteriaComponent implements OnInit, OnDestroy, AfterViewInit {
  PolicyCriteriaTypes = PolicyCriteriaTypes;
  @ViewChildren(NgTemplateRefDirective) templates!: QueryList<NgTemplateRefDirective>;
  @ViewChild("ViewAirlineModel") ViewAirlineModel!: TemplateRef<any>
  templateMap: { [key: string]: TemplateRef<any> } = {};
  commonApiLists: PolicyCriteriaCommonApiLists = {
    travelPolicyCriterial: [
      { name: PolicyCriteriaTypes.MarketType, class: "custom-popup-gen-market-type", edit: true, remove: true, view: false, isSelected: false },
      { name: PolicyCriteriaTypes.Airline, class: "custom-popup-gen-market-type", edit: true, remove: true, view: true, isSelected: false },
      { name: PolicyCriteriaTypes.Origin, class: "custom-popup-gen-origin-type", edit: true, remove: true, view: false, isSelected: false },
      { name: PolicyCriteriaTypes.Destination, class: "custom-popup-gen-origin-type", edit: true, remove: true, view: false, isSelected: false },
      { name: PolicyCriteriaTypes.CostRange, class: "custom-popup-gen-market-type", edit: true, remove: true, view: false, isSelected: false },
      { name: PolicyCriteriaTypes.BookingDate, class: "custom-popup-gen-market-type", edit: true, remove: true, view: false, isSelected: false },
      { name: PolicyCriteriaTypes.TripDate, class: "custom-popup-gen-market-type", edit: true, remove: true, view: false, isSelected: false },
      { name: PolicyCriteriaTypes.NumberOfStops, class: "custom-popup-gen-market-type", edit: true, remove: true, view: false, isSelected: false },
      { name: PolicyCriteriaTypes.LayoverDuration, class: "custom-popup-gen-market-type", edit: true, remove: true, view: false, isSelected: false },
    ],
    airlineCriteria: [],
    // originSetFor: ["Region", "Zone", "Country", "City", "Airport"],
    originSetFor: ["Country", "City", "Airport"],
    originSetForController: { Region: "region", Zone: "zone", Country: "addCountry", City: "addCity", Airport: "addAirport" },
    originRegion: [],
    originZone: [],
    dropdowns: {
      originCountry: [{ pipe: [], all: [] }],
      originCity: [{ pipe: [], all: [] }],
      originAirport: [{ pipe: [], all: [] }],
      destinationCountry: [{ pipe: [], all: [] }],
      destinationCity: [{ pipe: [], all: [] }],
      destinationAirport: [{ pipe: [], all: [] }],
    },
    noOfStops: [
      { bindValue: "0", bindLabel: "Direct" },
      { bindValue: "1", bindLabel: "1 Stop" },
      { bindValue: "2", bindLabel: "2 Stop" },
      { bindValue: "2+", bindLabel: "2+ Stop" },
    ],
    noOfStopsNote: {
      0: "All non-stop flights will be in-policy.",
      1: "All flights with less than 1 stop will be in-policy.",
      2: "All flights with less than 2 stops will be in-policy.",
      '2+': "All flights with less than 2+ stops will be in-policy.",
    },
    check_country: {
      lists: [],
      isAdd: false
    },
    check_city: {
      lists: [],
      isAdd: false
    },
    check_airport: {
      lists: [],
      isAdd: false
    }
  };
  policyCriteriaCopyForm: FormGroup;
  policyCriteriaForm: PolicyCriteria;
  policyMatDialogRef!: MatDialogRef<any>;
  isChildVisible: { [key: string]: boolean } = {
    isBookFromCalendar: false,
    isBookToCalendar: false,
    isBookTripFromCalendar: false,
    isBookTripToCalendar: false,
  };
  popupsForm: FormGroup;
  filter: any = {
    searchPolicyValue: "",
    SearchValue: "",
    Criteria: ""
  }
  commonObj: any = {
    id: null,
    currentPopupIndex: null,
    popupType: "origin",
    isSubmitting: false,
    viewTableHeading: "",
    viewTableHead: [],
    viewTableRows: [],
    minDate: this._CommonService.getFormattedDate(new Date()),
    tempAirlineLists: []
  }
  policyList: any;
  policyName: any;
  private destroy$ = new Subject<void>();
  content:any;
  saveMode!:string;
  dictionaryContent:any;
  private originDestinationHydrationToken = 0;
  constructor(private _FormBuilder: FormBuilder, private _MatDialog: MatDialog, public _CommonService: CommonService, private _CamService: CamService, private _DatePipe: DatePipe, private _ActivatedRoute: ActivatedRoute, private _CryptoService: CryptoService, private _ToastrApiService: ToastrApiService, private _Router: Router, private _PolicyManagementService: PolicyManagementService, private _CompanyManagementService: CompanyManagementService, private _CookiesService:CookiesService, private contentService:PolicyContentService,private readonly dictionaryContentService: DisctionaryContent ) {
    this.policyCriteriaForm = {
      Air: "",
      Origin: "",
      OutPolicyReasion: "",
      MaxTripStayDays: 0,
      BeforeTripStart: 0,
      FareTolerance: 0,
      FareTolerancePercentage: false,
      NonRefundable: false,
      CallFor: "update",
      JourneyOWInbound: false,
      JourneyOWOutbound: false,
      JourneyRTInbound: false,
      JourneyRTOutbound: false,
      JourneyMultiDestination: false,
      MarketType: "",
      LayoverDuration: "",
      NumberOfStops: "",
      TripDateTo: "",
      TripDateFrom: "",
      BookingDateTo: "",
      BookingDateFrom: "",
      FareToCriteria: 0,
      FareFromCriteria: 0,
      DestinationType: "",
      DestinationAllowed: false,
      DestinationCriteria: "",
      OriginType: "",
      OriginAllowed: "",
      IsPointOfOrigin: false,
      FareToleranceType: "",
      FareToleranceTypeDom: "",
      FareToleranceDom: 0,
      IsEconomy: true,
      IsBusiness: false,
      IsFirst: false,
    };
    this.policyCriteriaCopyForm = this._FormBuilder.group({
      TravelPolicyId: 0,
      IsEconomy: true,
      IsBusiness: false,
      IsFirst: false,
      jouneryRule: this._FormBuilder.group({
        OW: true,
        RT: true,
        MCT: true,
      }, { validators: [this.atLeastOneCheckboxCheckedValidator()] }),
      outPolicyReasion: ["", [Validators.minLength(5), Validators.maxLength(250)]],
      maxTripStayDays: ['', [Validators.pattern(/^\d+$/)]],
      beforeTripStart: ['', [Validators.pattern(/^\d+$/)]],
      fareToleranceDomestic: ['', Validators.maxLength(100)],
      fareToleranceDomesticPercentage: false,
      fareToleranceInternational: ['', Validators.maxLength(100)],
      fareToleranceInternationalPercentage: false,
      nonRefundable: false,
      policyCriteria: this._FormBuilder.array([this.generatePolicyCriteria()])
    })
    this.popupsForm = this._FormBuilder.group({
      booking: this._FormBuilder.group({
        from: [this._CommonService.getFormattedDate(new Date()), Validators.required],
        to: ['', Validators.required],
      }),
      trip: this._FormBuilder.group({
        from: [this._CommonService.getFormattedDate(new Date()), Validators.required],
        to: ['', Validators.required],
      }),
      origin: this._FormBuilder.group({
        setFor: ['Country', Validators.required],
        region: [null, Validators.required],
        zone: [null, Validators.required],
        inPolicy: ["Allowed", Validators.required],
        addCountry: this._FormBuilder.array([this.anotherCountryGroup()]),
        addCity: this._FormBuilder.array([this.anotherCityGroup()]),
        addAirport: this._FormBuilder.array([this.anotherAirportGroup()]),
      }),
      destination: this._FormBuilder.group({
        setFor: ['Country', Validators.required],
        region: [null, Validators.required],
        zone: [null, Validators.required],
        inPolicy: ["Allowed", Validators.required],
        addCountry: this._FormBuilder.array([this.anotherCountryGroup()]),
        addCity: this._FormBuilder.array([this.anotherCityGroup()]),
        addAirport: this._FormBuilder.array([this.anotherAirportGroup()]),
      }),
      MarketType: ["DOM", Validators.required],
      AirlineCriteria: ["", Validators.required],
      costRange: this._FormBuilder.group({
        from: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
        to: ['', [Validators.required, Validators.pattern(/^\d+$/)]]
      }),
      NumberofStops: ["0", Validators.required],
      Layover: this._FormBuilder.group({
        hh: ["", [Validators.required, Validators.min(0), Validators.max(23), Validators.pattern(/^([0-5]?[0-9])$/)]],
        mm: ["", [Validators.required, Validators.min(0), Validators.max(59), Validators.pattern(/^([0-5]?[0-9])$/)]],
      }),
    })
  }

  private isZeroOrEmpty(value: unknown): boolean {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed.length === 0) return true;
      return trimmed === '0';
    }
    if (typeof value === 'number') return value === 0;
    return false;
  }

  private normalizeOptionalNumericInput(value: unknown): string {
    return this.isZeroOrEmpty(value) ? '' : String(value);
  }
  ngOnInit(){
    this._CamService.policySaveMode$.pipe(takeUntil(this.destroy$)).subscribe(m=>{
      this.saveMode=m;
    });
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    });
    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.dictionaryContent = res;
    });
  }
  ngAfterViewInit() {
    this.getDropdowns("airline");
    this.getDropdowns("region");
    this.getDropdowns("zone");
    sessionStorage.removeItem("psq");
    this.templates.forEach((t) => {
      this.templateMap[t.name] = t.template;
    })
    if (!!this._ActivatedRoute.snapshot.queryParams['enc']) {
      this.commonObj.id = this._CryptoService.decryptData(this._ActivatedRoute.snapshot.queryParams['enc'])?.policyID;
      this._CamService.getPolicyManagementByID(this.commonObj.id).then(async ($: any) => {
        if ($.data?.[10]?.Branchlist?.length) {
          let form = $.data?.[10].Branchlist[0];
          this.policyCriteriaCopyForm.get("TravelPolicyId")?.setValue(form?.TravelPolicy_Id || 0);
          (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).removeAt(0);
          if (form.MarketType && (typeof form.MarketType !== 'object' || Object.keys(form.MarketType).length > 0)) {
            this.createPolicyCriteria();
            this.commonObj.currentPopupIndex = (this.policyCriteriaCopyForm.value.policyCriteria?.length - 1) || 0;
            (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("key")?.setValue("Market type");
            this.popupsForm.get("MarketType")?.setValue(form.MarketType == "Domestic" ? "DOM" : "INT");
            this.savePopup("MarketTypeModel", form.MarketType == "Domestic" ? "DOM" : "INT");
          } if (form.Airline_Criteria && (typeof form.Airline_Criteria !== 'object' || Object.keys(form.Airline_Criteria)?.length > 0)) {
            this.createPolicyCriteria();
            this.commonObj.currentPopupIndex = (this.policyCriteriaCopyForm.value.policyCriteria?.length - 1) || 0;
            (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("key")?.setValue("Airline");
            this.savePopup("AirlineModel", form.Airline_Criteria.split(","));
            this.commonApiLists.airlineCriteria.forEach(($airline: any) => {
              if (form.Airline_Criteria?.split(",")?.includes($airline.AirlineCode)) {
                $airline.isSelected = true;
              }
            })
          } if ((form.Origin_Type ?? (form as any).OriginType) && ((typeof (form.Origin_Type ?? (form as any).OriginType) !== 'object') || Object.keys((form.Origin_Type ?? (form as any).OriginType) as any)?.length > 0)) {
            // Support both old API fields (Origin_Type/Origin_Criteria/Origin_Allowed) and new ones (OriginType/Origin/OriginAllowed).
            this.createPolicyCriteria();
            this.commonObj.currentPopupIndex = (this.policyCriteriaCopyForm.value.policyCriteria?.length - 1) || 0;
            (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("key")?.setValue("Origin");
            this.commonObj.popupType = "Origin";
            const originSetFor = (form.Origin_Type ?? (form as any).OriginType ?? "").toString();
            const originCriteriaStr = (form.Origin_Criteria ?? (form as any).Origin ?? "").toString();
            const originAllowedVal = (form.Origin_Allowed ?? (form as any).OriginAllowed ?? false) as any;
            const isAllowed = originAllowedVal === true || String(originAllowedVal).toLowerCase() === 'true' || String(originAllowedVal) === '1';
            const inPolicy = isAllowed ? "Allowed" : "Restricted";

            const originGroup = this.popupsForm.get("origin") as FormGroup;
            originGroup.patchValue({ setFor: originSetFor, region: null, zone: null, inPolicy });

            const tokens = originCriteriaStr
              .split(",")
              .map((t: string) => t.trim())
              .filter(Boolean);

            // Reset and re-build addCity/addAirport/addCountry based on selected setFor.
            const resetFormArray = (arrayName: string) => {
              const fa = originGroup.get(arrayName) as FormArray;
              while (fa.length > 0) fa.removeAt(0);
            };

            if (originSetFor.toLowerCase() === 'city') {
              resetFormArray('addCity');

              // New format: country|city (comma-separated)
              const byCountry: Record<string, Set<string>> = {};
              tokens.forEach((tok: string) => {
                const parts = tok.split("|").map((p: string) => p.trim()).filter(Boolean);
                if (parts.length >= 2) {
                  const cc = parts[0];
                  const city = parts[1];
                  byCountry[cc] = byCountry[cc] ?? new Set<string>();
                  byCountry[cc].add(city);
                }
              });

              const countries = Object.keys(byCountry);
              countries.forEach(() => (originGroup.get('addCity') as FormArray).push(this.anotherCityGroup.bind(this)()));

              for (let i = 0; i < countries.length; i++) {
                await this.getDropdowns('city', i);
                const cc = countries[i];
                (originGroup.get('addCity') as FormArray).at(i).get('country')?.setValue(cc);
                await this.getDropdowns('city_country', i);
                (originGroup.get('addCity') as FormArray).at(i).get('city')?.setValue(Array.from(byCountry[cc]));
                this.mergeSelectedOptionsIntoPipe('originCity', i, Array.from(byCountry[cc]), 'CityCode');
                this.commonApiUniqueListsAssigner('check_city', i);
              }
            } else if (originSetFor.toLowerCase() === 'airport') {
              resetFormArray('addAirport');

              // New format: country|city|airport
              const byCountry: Record<string, { cities: Set<string>; airports: Set<string> }> = {};
              tokens.forEach((tok: string) => {
                const parts = tok.split("|").map((p: string) => p.trim()).filter(Boolean);
                if (parts.length >= 2) {
                  const cc = parts[0];
                  const city = parts[1];
                  byCountry[cc] = byCountry[cc] ?? { cities: new Set<string>(), airports: new Set<string>() };
                  byCountry[cc].cities.add(city);
                  if (parts.length >= 3 && parts[2]) {
                    byCountry[cc].airports.add(parts[2]);
                  }
                }
              });

              const countries = Object.keys(byCountry);
              countries.forEach(() => (originGroup.get('addAirport') as FormArray).push(this.anotherAirportGroup.bind(this)()));

              for (let i = 0; i < countries.length; i++) {
                await this.getDropdowns('airport', i);
                const cc = countries[i];
                (originGroup.get('addAirport') as FormArray).at(i).get('country')?.setValue(cc);
                await this.getDropdowns('airport_country', i);
                const cityCodes = Array.from(byCountry[cc].cities);
                (originGroup.get('addAirport') as FormArray).at(i).get('city')?.setValue(cityCodes);
                this.mergeSelectedOptionsIntoPipe(`originCity`, i, cityCodes, 'CityCode');
                await this.getDropdowns('airport_city', i);
                const airportCodes = Array.from(byCountry[cc].airports);
                (originGroup.get('addAirport') as FormArray).at(i).get('airport')?.setValue(airportCodes);
                this.mergeSelectedOptionsIntoPipe(`originAirport`, i, airportCodes, 'AirportCode');
                this.commonApiUniqueListsAssigner('check_airport', i);
              }
            } else if (originSetFor.toLowerCase() === 'country') {
              resetFormArray('addCountry');
              (originGroup.get('addCountry') as FormArray).push(this.anotherCountryGroup.bind(this)());
              await this.getDropdowns('country', 0);
              (originGroup.get('addCountry') as FormArray).at(0).get('country')?.setValue(tokens);
              this.commonApiUniqueListsAssigner('check_country', 0);
            }

            // IMPORTANT: pass isHTML=false so savePopup reads addCity/addAirport/addCountry (zone UI removed).
            this.savePopup("OriginModel", originGroup.value, true, false);
          } if ((form.Destination_Type ?? (form as any).DestinationType) && ((typeof (form.Destination_Type ?? (form as any).DestinationType) !== 'object') || Object.keys((form.Destination_Type ?? (form as any).DestinationType) as any)?.length > 0)) {
            // Support both old API fields (Destination_Type/Destination_Criteria/Destination_Allowed) and new ones.
            this.createPolicyCriteria();
            this.commonObj.currentPopupIndex = (this.policyCriteriaCopyForm.value.policyCriteria?.length - 1) || 0;
            (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("key")?.setValue("Destination");
            this.commonObj.popupType = "Destination";
            const destSetFor = (form.Destination_Type ?? (form as any).DestinationType ?? "").toString();
            const destCriteriaStr = (form.Destination_Criteria ?? (form as any).DestinationCriteria ?? "").toString();
            const destAllowedVal = (form.Destination_Allowed ?? (form as any).DestinationAllowed ?? false) as any;
            const destIsAllowed = destAllowedVal === true || String(destAllowedVal).toLowerCase() === 'true' || String(destAllowedVal) === '1';
            const destInPolicy = destIsAllowed ? "Allowed" : "Restricted";

            const destGroup = this.popupsForm.get("destination") as FormGroup;
            destGroup.patchValue({ setFor: destSetFor, region: null, zone: null, inPolicy: destInPolicy });

            const tokens = destCriteriaStr
              .split(",")
              .map((t: string) => t.trim())
              .filter(Boolean);

            const resetFormArray = (arrayName: string) => {
              const fa = destGroup.get(arrayName) as FormArray;
              while (fa.length > 0) fa.removeAt(0);
            };

            if (destSetFor.toLowerCase() === 'city') {
              resetFormArray('addCity');
              const byCountry: Record<string, Set<string>> = {};
              tokens.forEach((tok: string) => {
                const parts = tok.split("|").map((p: string) => p.trim()).filter(Boolean);
                if (parts.length >= 2) {
                  const cc = parts[0];
                  const city = parts[1];
                  byCountry[cc] = byCountry[cc] ?? new Set<string>();
                  byCountry[cc].add(city);
                }
              });

              const countries = Object.keys(byCountry);
              countries.forEach(() => (destGroup.get('addCity') as FormArray).push(this.anotherCityGroup.bind(this)()));

              for (let i = 0; i < countries.length; i++) {
                await this.getDropdowns('city', i);
                const cc = countries[i];
                (destGroup.get('addCity') as FormArray).at(i).get('country')?.setValue(cc);
                await this.getDropdowns('city_country', i);
                (destGroup.get('addCity') as FormArray).at(i).get('city')?.setValue(Array.from(byCountry[cc]));
                this.mergeSelectedOptionsIntoPipe('destinationCity', i, Array.from(byCountry[cc]), 'CityCode');
                this.commonApiUniqueListsAssigner('check_city', i);
              }
            } else if (destSetFor.toLowerCase() === 'airport') {
              resetFormArray('addAirport');
              const byCountry: Record<string, { cities: Set<string>; airports: Set<string> }> = {};
              tokens.forEach((tok: string) => {
                const parts = tok.split("|").map((p: string) => p.trim()).filter(Boolean);
                if (parts.length >= 2) {
                  const cc = parts[0];
                  const city = parts[1];
                  byCountry[cc] = byCountry[cc] ?? { cities: new Set<string>(), airports: new Set<string>() };
                  byCountry[cc].cities.add(city);
                  if (parts.length >= 3 && parts[2]) {
                    byCountry[cc].airports.add(parts[2]);
                  }
                }
              });

              const countries = Object.keys(byCountry);
              countries.forEach(() => (destGroup.get('addAirport') as FormArray).push(this.anotherAirportGroup.bind(this)()));

              for (let i = 0; i < countries.length; i++) {
                await this.getDropdowns('airport', i);
                const cc = countries[i];
                (destGroup.get('addAirport') as FormArray).at(i).get('country')?.setValue(cc);
                await this.getDropdowns('airport_country', i);
                const cityCodes = Array.from(byCountry[cc].cities);
                (destGroup.get('addAirport') as FormArray).at(i).get('city')?.setValue(cityCodes);
                this.mergeSelectedOptionsIntoPipe('destinationCity', i, cityCodes, 'CityCode');
                await this.getDropdowns('airport_city', i);
                const airportCodes = Array.from(byCountry[cc].airports);
                (destGroup.get('addAirport') as FormArray).at(i).get('airport')?.setValue(airportCodes);
                this.mergeSelectedOptionsIntoPipe('destinationAirport', i, airportCodes, 'AirportCode');
                this.commonApiUniqueListsAssigner('check_airport', i);
              }
            } else if (destSetFor.toLowerCase() === 'country') {
              resetFormArray('addCountry');
              (destGroup.get('addCountry') as FormArray).push(this.anotherCountryGroup.bind(this)());
              await this.getDropdowns('country', 0);
              (destGroup.get('addCountry') as FormArray).at(0).get('country')?.setValue(tokens);
              this.commonApiUniqueListsAssigner('check_country', 0);
            }

            this.savePopup("DestinationModel", destGroup.value, true, false);
          } if (form.FareFrom_Criteria && (typeof form.FareFrom_Criteria !== 'object' || Object.keys(form.FareFrom_Criteria).length > 0)) {
            this.createPolicyCriteria();
            this.commonObj.currentPopupIndex = (this.policyCriteriaCopyForm.value.policyCriteria?.length - 1) || 0;
            (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("key")?.setValue("Cost range");
            this.savePopup("CostRangeModel", { from: form.FareFrom_Criteria, to: form.FareTo_Criteria });
            this.popupsForm.get("costRange")?.patchValue({ from: form.FareFrom_Criteria, to: form.FareTo_Criteria });
          } if (form.BookingDate_From && (typeof form.BookingDate_From !== 'object' || Object.keys(form.BookingDate_From).length > 0)) {
            this.createPolicyCriteria();
            this.commonObj.currentPopupIndex = (this.policyCriteriaCopyForm.value.policyCriteria?.length - 1) || 0;
            (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("key")?.setValue("Booking date");
            this.savePopup("BookingDateModel", { from: new Date(form.BookingDate_From).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }), to: new Date(form.BookingDate_To).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }) });
            this.popupsForm.get("booking")?.patchValue({ from: new Date(form.BookingDate_From).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }), to: new Date(form.BookingDate_To).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }) });
          } if (form.TripDate_From && (typeof form.TripDate_From !== 'object' || Object.keys(form.TripDate_From).length > 0)) {
            this.createPolicyCriteria();
            this.commonObj.currentPopupIndex = (this.policyCriteriaCopyForm.value.policyCriteria?.length - 1) || 0;
            (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("key")?.setValue("Trip date");
            this.savePopup("TripDateModel", { from: new Date(form.TripDate_From).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }), to: new Date(form.TripDate_To).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }) });
            this.popupsForm.get("trip")?.patchValue({ from: new Date(form.TripDate_From).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }), to: new Date(form.TripDate_To).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }) });
          } if (form.NumberofStops && (typeof form.NumberofStops !== 'object' || Object.keys(form.NumberofStops).length > 0)) {
            this.createPolicyCriteria();
            this.commonObj.currentPopupIndex = (this.policyCriteriaCopyForm.value.policyCriteria?.length - 1) || 0;
            (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("key")?.setValue("No. of stops");
            this.savePopup("NoOfStopsModel", form.NumberofStops);
            this.popupsForm.get("NumberofStops")?.setValue(form.NumberofStops);
          } if (form.LayoverDuration && (typeof form.LayoverDuration !== 'object' || Object.keys(form.LayoverDuration).length > 0)) {
            this.createPolicyCriteria();
            this.commonObj.currentPopupIndex = (this.policyCriteriaCopyForm.value.policyCriteria?.length - 1) || 0;
            (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("key")?.setValue("Layover duration");
            this.savePopup("LayoverDurationModel", { hh: form.LayoverDuration.split(":")[0], mm: form.LayoverDuration.split(":")[1] });
            this.popupsForm.get("Layover")?.patchValue({ hh: form.LayoverDuration.split(":")[0], mm: form.LayoverDuration.split(":")[1] });
          }
          if (form.Journey_OW_Inbound || form.Journey_OW_Outbound || form.Journey_RT_Inbound || form.Journey_RT_Outbound || form.Journey_MultiDestination) {
            if (form.Journey_OW_Inbound || form.Journey_OW_Outbound) {
              this.policyCriteriaCopyForm.get("jouneryRule.OW")?.setValue(true);
            } else {
              this.policyCriteriaCopyForm.get("jouneryRule.OW")?.setValue(false);
            }
            if (form.Journey_RT_Inbound || form.Journey_RT_Outbound) {
              this.policyCriteriaCopyForm.get("jouneryRule.RT")?.setValue(true);
            } else {
              this.policyCriteriaCopyForm.get("jouneryRule.RT")?.setValue(false);
            }
            if (form.Journey_MultiDestination) {
              this.policyCriteriaCopyForm.get("jouneryRule.MCT")?.setValue(true);
            } else {
              this.policyCriteriaCopyForm.get("jouneryRule.MCT")?.setValue(false);
            }
          } else {
            this.policyCriteriaCopyForm.get("jouneryRule.OW")?.setValue(false);
            this.policyCriteriaCopyForm.get("jouneryRule.RT")?.setValue(false);
            this.policyCriteriaCopyForm.get("jouneryRule.MCT")?.setValue(false);
          }
          if (form.OutPolicy_Reson && (typeof form.OutPolicy_Reson !== 'object' || Object.keys(form.OutPolicy_Reson).length > 0)) {
            this.policyCriteriaCopyForm.get("outPolicyReasion")?.setValue(form.OutPolicy_Reson);
          } if (form.Max_TripStayDays && (typeof form.Max_TripStayDays !== 'object' || Object.keys(form.Max_TripStayDays).length > 0)) {
            this.policyCriteriaCopyForm.get("maxTripStayDays")?.setValue(form.Max_TripStayDays);
          } if (form.DaysBefore_TripStart && (typeof form.DaysBefore_TripStart !== 'object' || Object.keys(form.DaysBefore_TripStart).length > 0)) {
            this.policyCriteriaCopyForm.get("beforeTripStart")?.setValue(form.DaysBefore_TripStart);
          } if (!this.isZeroOrEmpty(form.FareToleranceDom) && (typeof form.FareToleranceDom !== 'object' || Object.keys(form.FareToleranceDom).length > 0)) {
            this.policyCriteriaCopyForm.get("fareToleranceDomestic")?.setValue(this.normalizeOptionalNumericInput(form.FareToleranceDom));
          } if (!this.isZeroOrEmpty(form.FareTolerance) && (typeof form.FareTolerance !== 'object' || Object.keys(form.FareTolerance).length > 0)) {
            this.policyCriteriaCopyForm.get("fareToleranceInternational")?.setValue(this.normalizeOptionalNumericInput(form.FareTolerance));
          } if (form.FareToleranceTypeDom && (typeof form.FareToleranceTypeDom !== 'object' || Object.keys(form.FareToleranceTypeDom).length > 0)) {
            this.policyCriteriaCopyForm.get("fareToleranceDomesticPercentage")?.setValue(form.FareToleranceTypeDom === "P");
          } if (form.FareToleranceType && (typeof form.FareToleranceType !== 'object' || Object.keys(form.FareToleranceType).length > 0)) {
            this.policyCriteriaCopyForm.get("fareToleranceInternationalPercentage")?.setValue(form.FareToleranceType === "P");
          } if (form.Book_NonRefundable && (typeof form.Book_NonRefundable !== 'object' || Object.keys(form.Book_NonRefundable).length > 0)) {
            this.policyCriteriaCopyForm.get("nonRefundable")?.setValue(form.Book_NonRefundable);
          }
          if (typeof form.Cabin_Economy !== 'object') {
            this.policyCriteriaCopyForm.get('IsEconomy')?.setValue(form.Cabin_Economy);
          }
          if (typeof form.Cabin_Business !== 'object') {
            this.policyCriteriaCopyForm.get('IsBusiness')?.setValue(form.Cabin_Business);
          }
          if (typeof form.Cabin_First !== 'object') {
            this.policyCriteriaCopyForm.get('IsFirst')?.setValue(form.Cabin_First);
          }
          this.findPolicyKey();

          // Ensure at least one empty policy criteria row is present by default
          const policyArray = this.policyCriteriaCopyForm.get('policyCriteria') as FormArray;
          if (policyArray && policyArray.length === 0) {
            policyArray.push(this.generatePolicyCriteria());
          }
        }
      })
    }

    //GTM use
    this._PolicyManagementService.policyListValue.subscribe((result: any) => {
      this.policyList = result
    })

    // this._PolicyManagementService.travelPolicyName.subscribe((result) => {
    //   this.policyName = result
    // })

    this.policyName = this._CookiesService.getFromStorage()
    this._PolicyManagementService.page_landing('Policy Management - Policy Criteria', this.policyList.length, 'Policy Management Workflow')//GTM use
  }
  generateAirline(airlineLists: any[]) {
    airlineLists.forEach(({ AirlineCode, AirlineName }) => {
      this.commonApiLists.airlineCriteria.push({ AirlineCode, AirlineName, isSelected: false, isVisible: true })
    })
  }
  getPType(): { p: string, c: string, k: string } {
    let pType: { p: string, c: string, k: string } = {
      p: this.commonObj.popupType.toLowerCase() === "origin" ? "origin" : "destination",
      c: this.commonObj.popupType.toLowerCase() === "origin" ? "Origin" : "Destination",
      k: this.commonObj.popupType.toLowerCase() === "origin" ? "Origin" : "DestinationCriteria",
    };
    return pType;
  }

  private mergeSelectedOptionsIntoPipe(
    dropdownKey: string,
    index: number,
    selectedCodes: string[],
    codeField: 'CountryCode' | 'CityCode' | 'AirportCode'
  ): void {
    if (!selectedCodes?.length) {
      return;
    }
    this.ensureDropdownIndex(dropdownKey, index);
    const dropdown = (this.commonApiLists.dropdowns as any)[dropdownKey][index];
    if (!dropdown?.all?.length) {
      return;
    }
    const pipeCodes = new Set((dropdown.pipe || []).map((item: any) => item?.[codeField]));
    const missing = dropdown.all.filter(
      (item: any) => selectedCodes.includes(item?.[codeField]) && !pipeCodes.has(item?.[codeField])
    );
    if (missing.length) {
      dropdown.pipe = [...(dropdown.pipe || []), ...missing];
    }
  }

  private resetOriginDestinationDropdowns(groupKey: 'origin' | 'destination'): void {
    Object.keys(this.commonApiLists.dropdowns)
      .filter(key => key.startsWith(groupKey))
      .forEach(key => {
        (this.commonApiLists.dropdowns as any)[key] = [{ pipe: [], all: [] }];
      });
  }

  private async hydrateOriginDestinationFromSaved(
    type: PolicyCriteriaTypes.Origin | PolicyCriteriaTypes.Destination
  ): Promise<void> {
    const groupKey = type === PolicyCriteriaTypes.Origin ? 'origin' : 'destination';
    const typeField = type === PolicyCriteriaTypes.Origin ? 'OriginType' : 'DestinationType';
    const criteriaField = type === PolicyCriteriaTypes.Origin ? 'Origin' : 'DestinationCriteria';
    const allowedField = type === PolicyCriteriaTypes.Origin ? 'OriginAllowed' : 'DestinationAllowed';

    this.commonObj.popupType = type;
    const setFor = String((this.policyCriteriaForm as any)[typeField] ?? 'Country');
    const criteriaStr = String((this.policyCriteriaForm as any)[criteriaField] ?? '');
    const allowedVal = (this.policyCriteriaForm as any)[allowedField];
    const isAllowed = allowedVal === true || String(allowedVal).toLowerCase() === 'true' || String(allowedVal) === '1';
    const inPolicy = isAllowed ? 'Allowed' : 'Restricted';

    const group = this.popupsForm.get(groupKey) as FormGroup | null;
    if (!group) {
      return;
    }

    const hydrationToken = ++this.originDestinationHydrationToken;
    group.patchValue({ setFor, region: null, zone: null, inPolicy });

    const tokens = criteriaStr
      .split(',')
      .map((t: string) => t.trim())
      .filter(Boolean);

    const resetFormArray = (arrayName: string) => {
      const fa = group.get(arrayName) as FormArray;
      while (fa.length > 0) {
        fa.removeAt(0);
      }
    };

    this.resetOriginDestinationDropdowns(groupKey);

    if (setFor.toLowerCase() === 'city') {
      resetFormArray('addCity');
      const byCountry: Record<string, Set<string>> = {};
      tokens.forEach((tok: string) => {
        const parts = tok.split('|').map((p: string) => p.trim()).filter(Boolean);
        if (parts.length >= 2) {
          const cc = parts[0];
          const city = parts[1];
          byCountry[cc] = byCountry[cc] ?? new Set<string>();
          byCountry[cc].add(city);
        } else if (parts.length === 1) {
          byCountry[''] = byCountry[''] ?? new Set<string>();
          byCountry[''].add(parts[0]);
        }
      });

      const countries = Object.keys(byCountry);
      if (!countries.length) {
        group.get('addCity')?.markAsPristine();
        return;
      }

      countries.forEach(() => (group.get('addCity') as FormArray).push(this.anotherCityGroup()));

      for (let i = 0; i < countries.length; i++) {
        if (hydrationToken !== this.originDestinationHydrationToken) {
          return;
        }
        const cc = countries[i];
        await this.getDropdowns('city', i);
        if (cc) {
          (group.get('addCity') as FormArray).at(i).get('country')?.setValue(cc);
          await this.getDropdowns('city_country', i);
        }
        const cityCodes = Array.from(byCountry[cc]);
        (group.get('addCity') as FormArray).at(i).get('city')?.setValue(cityCodes);
        this.mergeSelectedOptionsIntoPipe(`${groupKey}City`, i, cityCodes, 'CityCode');
        this.commonApiUniqueListsAssigner('check_city', i);
      }
    } else if (setFor.toLowerCase() === 'airport') {
      resetFormArray('addAirport');
      const byCountry: Record<string, { cities: Set<string>; airports: Set<string> }> = {};
      tokens.forEach((tok: string) => {
        const parts = tok.split('|').map((p: string) => p.trim()).filter(Boolean);
        if (parts.length >= 2) {
          const cc = parts[0];
          const city = parts[1];
          byCountry[cc] = byCountry[cc] ?? { cities: new Set<string>(), airports: new Set<string>() };
          byCountry[cc].cities.add(city);
          if (parts.length >= 3 && parts[2]) {
            byCountry[cc].airports.add(parts[2]);
          }
        }
      });

      const countries = Object.keys(byCountry);
      if (!countries.length) {
        return;
      }

      countries.forEach(() => (group.get('addAirport') as FormArray).push(this.anotherAirportGroup()));

      for (let i = 0; i < countries.length; i++) {
        if (hydrationToken !== this.originDestinationHydrationToken) {
          return;
        }
        const cc = countries[i];
        await this.getDropdowns('airport', i);
        (group.get('addAirport') as FormArray).at(i).get('country')?.setValue(cc);
        await this.getDropdowns('airport_country', i);
        const cityCodes = Array.from(byCountry[cc].cities);
        (group.get('addAirport') as FormArray).at(i).get('city')?.setValue(cityCodes);
        this.mergeSelectedOptionsIntoPipe(`${groupKey}City`, i, cityCodes, 'CityCode');
        await this.getDropdowns('airport_city', i);
        const airportCodes = Array.from(byCountry[cc].airports);
        (group.get('addAirport') as FormArray).at(i).get('airport')?.setValue(airportCodes);
        this.mergeSelectedOptionsIntoPipe(`${groupKey}Airport`, i, airportCodes, 'AirportCode');
        this.commonApiUniqueListsAssigner('check_airport', i);
      }
    } else if (setFor.toLowerCase() === 'country') {
      resetFormArray('addCountry');
      (group.get('addCountry') as FormArray).push(this.anotherCountryGroup());
      await this.getDropdowns('country', 0);
      const countryCodes = tokens.flatMap((tok: string) => {
        const parts = tok.split('|').map((p: string) => p.trim()).filter(Boolean);
        return parts.length >= 1 ? [parts[parts.length - 1]] : [];
      });
      (group.get('addCountry') as FormArray).at(0).get('country')?.setValue(countryCodes);
      this.mergeSelectedOptionsIntoPipe(`${groupKey}Country`, 0, countryCodes, 'CountryCode');
      this.commonApiUniqueListsAssigner('check_country', 0);
    }
  }

  getDropdowns(type: string, index: number = 0, preserveValues: boolean = false) {
    if (type == "region") {
      this.filter.Criteria = type;
    } else if (type === "zone") {
      this.filter.Criteria = type;
    } else if (type === "country") {
      this.filter.Criteria = type;
      // Zone selection UI is removed; load countries directly.
      this.filter.SearchValue = "";
      this.commonApiLists.dropdowns[this.getPType().p + "Country"][index] = { pipe: [], all: [] };
      (this.popupsForm.get(this.getPType().p)?.get("addCountry") as FormArray)?.at(index)?.get("country")?.setValue([]);
    } else if (type === "city") {
      this.filter.Criteria = "country";
      // Zone selection UI is removed; load countries directly for city selection.
      this.filter.SearchValue = "";
      this.commonApiLists.dropdowns[this.getPType().p + "Country"][index] = { pipe: [], all: [] };
      this.commonApiLists.dropdowns[this.getPType().p + "City"][index] = { pipe: [], all: [] };
      if (!preserveValues) {
        (this.popupsForm.get(this.getPType().p)?.get("addCity") as FormArray)?.at(index)?.get("country")?.setValue(null);
        (this.popupsForm.get(this.getPType().p)?.get("addCity") as FormArray)?.at(index)?.get("city")?.setValue([]);
      }
    } else if (type === "city_country") {
      this.filter.Criteria = "city";
      this.filter.SearchValue = this.popupsForm.value[this.getPType().p].addCity[index].country;
      this.commonApiLists.dropdowns[this.getPType().p + "City"][index] = { pipe: [], all: [] };
      if (!preserveValues) {
        (this.popupsForm.get(this.getPType().p)?.get("addCity") as FormArray)?.at(index)?.get("city")?.setValue([]);
      }
    } else if (type === "airport") {
      this.filter.Criteria = "country";
      // Zone selection UI is removed; load countries directly for airport selection.
      this.filter.SearchValue = "";
      this.commonApiLists.dropdowns[this.getPType().p + "Country"][index] = { pipe: [], all: [] };
      this.commonApiLists.dropdowns[this.getPType().p + "City"][index] = { pipe: [], all: [] };
      this.commonApiLists.dropdowns[this.getPType().p + "Airport"][index] = { pipe: [], all: [] };
      if (!preserveValues) {
        (this.popupsForm.get(this.getPType().p)?.get("addAirport") as FormArray)?.at(index)?.get("country")?.setValue(null);
        (this.popupsForm.get(this.getPType().p)?.get("addAirport") as FormArray)?.at(index)?.get("city")?.setValue([]);
        (this.popupsForm.get(this.getPType().p)?.get("addAirport") as FormArray)?.at(index)?.get("airport")?.setValue([]);
      }
    } else if (type === "airport_country") {
      this.filter.Criteria = "city";
      this.filter.SearchValue = this.popupsForm.value[this.getPType().p].addAirport[index].country;
      this.commonApiLists.dropdowns[this.getPType().p + "City"][index] = { pipe: [], all: [] };
      this.commonApiLists.dropdowns[this.getPType().p + "Airport"][index] = { pipe: [], all: [] };
      if (!preserveValues) {
        (this.popupsForm.get(this.getPType().p)?.get("addAirport") as FormArray)?.at(index)?.get("city")?.setValue([]);
        (this.popupsForm.get(this.getPType().p)?.get("addAirport") as FormArray)?.at(index)?.get("airport")?.setValue([]);
      }
    } else if (type === "airport_city") {
      this.filter.Criteria = "airport";
      this.filter.SearchValue = this.popupsForm.value[this.getPType().p].addAirport[index].city?.join(",");
      this.commonApiLists.dropdowns[this.getPType().p + "Airport"][index] = { pipe: [], all: [] };
      if (!preserveValues) {
        (this.popupsForm.get(this.getPType().p)?.get("addAirport") as FormArray)?.at(index)?.get("airport")?.setValue([]);
      }
    } else if (type === "destination_region") {
      this.filter.Criteria = "region";
      this.filter.SearchValue = this.popupsForm.value.destination.zone;
    } else if (type === "destination_country") {
      this.filter.Criteria = "country";
      this.filter.SearchValue = this.popupsForm.value.destination.region;
    } else if (type === "airline") {
      this.filter.Criteria = "airline";
      this.filter.SearchValue = '';
    }
    return this._CamService.getZoneCountryCityRegion(this.filter).then(($res: any) => {
      if (!!$res.data?.length) {
        if ($res.data[0]?.CityCode) {
          $res.data?.forEach(($city: any) => {
            $city.CityCode = $city.CityCode.trim();
            $city.CityName = $city.CityName.trim();
          })
        } else if ($res.data[0]?.CountryCode) {
          $res.data?.forEach(($city: any) => {
            $city.CountryCode = $city.CountryCode.trim();
            $city.CountryName = $city.CountryName.trim();
          })
        } else if ($res.data[0]?.AirportCode) {
          $res.data?.forEach(($city: any) => {
            $city.AirportCode = $city.AirportCode.trim();
            $city.AirportName = $city.AirportName.trim();
          })
        }
      }
      if (type == "region") {
        this.commonApiLists.originRegion = $res.data;
      } else if (type === "zone") {
        this.commonApiLists.originZone = $res.data;
      } else if (["country", "city", "airport"].includes(type)) {
        let copy: any[] = [];
        if (type === "country") {
          let lists: any[] = (this.popupsForm.get(`${this.getPType().p}.addCountry`) as FormArray).value;
          let scope: any[] = lists.filter(($list: any) => $list.zone === lists[index].zone && !!$list.country?.length)?.map(($listMap: any) => $listMap.country).flat();
          let currentScope = lists[index];
          if (lists.map(($list: any) => $list.zone).includes(currentScope.zone)) {
            copy = $res.data?.filter(($countries: any) => !scope.includes($countries.CountryCode));
          }
        }
        this.commonApiLists.dropdowns[this.getPType().p + "Country"][index] = {
          pipe: !!copy.length ? copy : $res.data,
          all: $res.data
        }
      } else if (["city_country", "airport_country"].includes(type)) {
        let copy: any[] = [];
        if (type === "city_country") {
          let lists: any[] = (this.popupsForm.get(`${this.getPType().p}.addCity`) as FormArray).value;
          const currentCountry = lists[index]?.country;
          let scope: any[] = lists
            .filter(($list: any, rowIdx: number) => rowIdx !== index && !!$list?.country && $list.country === currentCountry)
            ?.map(($listMap: any) => $listMap.city)
            .flat();
          copy = $res.data?.filter(($countries: any) => !scope.includes($countries.CityCode));
        } else if (type === "airport_country") {
          let lists: any[] = (this.popupsForm.get(`${this.getPType().p}.addAirport`) as FormArray).value;
          const currentCountry = lists[index]?.country;
          let scope: any[] = lists
            .filter(($list: any, rowIdx: number) => rowIdx !== index && !!$list?.country && $list.country === currentCountry)
            ?.map(($listMap: any) => $listMap.city)
            .flat();
          copy = $res.data?.filter(($countries: any) => !scope.includes($countries.CityCode));
        }
        this.commonApiLists.dropdowns[this.getPType().p + "City"][index] = {
          pipe: (!!copy.length ? copy : $res.data),
          all: $res.data
        }
      } else if (["airport_city"].includes(type)) {
        let copy: any[] = [];
        let lists: any[] = (this.popupsForm.get(`${this.getPType().p}.addAirport`) as FormArray).value;
        let scope: any[] = lists
          .filter(($list: any, rowIdx: number) => rowIdx !== index && !!$list.airport?.length)
          .map(($listMap: any) => $listMap.airport)
          .flat();
        copy = $res.data?.filter(($countries: any) => !scope.includes($countries.AirportCode));
        this.commonApiLists.dropdowns[this.getPType().p + "Airport"][index] = {
          pipe: !!copy.length ? copy : $res.data,
          all: $res.data
        }
      } else if (type === "airline") {
        this.generateAirline($res.data);
      }
      /*
        Unique dropdowns value filter
      */
      this.commonApiUniqueListsAssigner(type, index);
    })
  }
  commonApiUniqueListsAssigner(type: string, index: number) {
    switch (type) {
      case "check_country": this.commonApiUniqueLists(type, index, (this.popupsForm.get(`${this.getPType().p}.addCountry`) as FormArray).value, this.getPType().p + "Country"); break;
      case "check_city": this.commonApiUniqueLists(type, index, (this.popupsForm.get(`${this.getPType().p}.addCity`) as FormArray).value, this.getPType().p + "City"); break;
      case "check_airport": this.commonApiUniqueLists(type, index, (this.popupsForm.get(`${this.getPType().p}.addAirport`) as FormArray).value, this.getPType().p + "Airport"); break;
    }
  }

  private ensureDropdownIndex(dropdownKey: string, index: number): void {
    const list = (this.commonApiLists.dropdowns as any)[dropdownKey];
    if (!Array.isArray(list) || index < 0) return;

    while (list.length <= index) {
      list.push({ pipe: [], all: [] });
    }
  }

  addCountryGroup() {
    const formArray = this.popupsForm.get(`${this.getPType().p}.addCountry`) as FormArray;
    formArray.push(this.anotherCountryGroup());

    const idx = formArray.length - 1;
    this.ensureDropdownIndex(`${this.getPType().p}Country`, idx);
    this.getDropdowns('country', idx);
  }
  get getAnotherCountriesControl(): any[] {
    return (this.popupsForm.get(`${this.getPType().p}.addCountry`) as FormArray).controls;
  }
  anotherCountryGroup(): FormGroup {
    return this._FormBuilder.group({
      // Zone selection UI removed, but we keep the form control for backward compatibility.
      // Country selection is now directly loaded.
      zone: [null],
      country: [[], Validators.required],
      countryDropdown: []
    })
  }
  addCityGroup() {
    const formArray = this.popupsForm.get(`${this.getPType().p}.addCity`) as FormArray;
    formArray.push(this.anotherCityGroup());

    const idx = formArray.length - 1;
    this.ensureDropdownIndex(`${this.getPType().p}Country`, idx);
    this.ensureDropdownIndex(`${this.getPType().p}City`, idx);
    this.getDropdowns('city', idx);
  }
  get getAnotherCitiesControl(): any[] {
    return (this.popupsForm.get(`${this.getPType().p}.addCity`) as FormArray).controls;
  }
  anotherCityGroup(): FormGroup {
    return this._FormBuilder.group({
      // Zone selection UI removed, but we keep the form control for backward compatibility.
      zone: [null],
      country: [null, Validators.required],
      countryDropdown: [],
      city: [[], Validators.required],
      cityDropdown: []
    })
  }
  addAirportGroup() {
    const formArray = this.popupsForm.get(`${this.getPType().p}.addAirport`) as FormArray;
    formArray.push(this.anotherAirportGroup());

    const idx = formArray.length - 1;
    this.ensureDropdownIndex(`${this.getPType().p}Country`, idx);
    this.ensureDropdownIndex(`${this.getPType().p}City`, idx);
    this.ensureDropdownIndex(`${this.getPType().p}Airport`, idx);
    this.getDropdowns('airport', idx);
  }
  get getAnotherAirportControl(): any[] {
    return (this.popupsForm.get(`${this.getPType().p}.addAirport`) as FormArray).controls;
  }
  anotherAirportGroup(): FormGroup {
    return this._FormBuilder.group({
      // Zone selection UI removed, but we keep the form control for backward compatibility.
      zone: [null],
      country: [null, Validators.required],
      city: [[], Validators.required],
      airport: [[], Validators.required],
    })
  }
  createPolicyCriteria() {
    (this.policyCriteriaCopyForm.get('policyCriteria') as FormArray).push(this.generatePolicyCriteria());
  }
  generatePolicyCriteria(): FormGroup {
    return this._FormBuilder.group(
      {
        key: [null],
        value: [null],
      },
      { validators: [this.bothOrNoneFilledValidator('key', 'value')] }
    );
  }
  findPolicyKey() {
    let keys: string[] = this.policyCriteriaCopyForm.value.policyCriteria.map(($policy: any) => $policy.key);
    if (!!keys.length) {
      this.commonApiLists.travelPolicyCriterial.forEach(($policy: any) => {
        $policy.isSelected = keys.includes($policy.name)
      })
    }
  }
  policyKey(key: any, isSelected: boolean, policyIndex: number, isEdit: boolean) {
    this.commonObj.currentPopupIndex = policyIndex;
    this.commonObj.popupType = key;
    (this.commonObj as any).isEditPopup = isEdit;
    if (!!key) {
      let panelClass: string = "";
      this.commonApiLists.travelPolicyCriterial.forEach(($policy: any) => {
        if ($policy.name == key && isSelected) {
          panelClass = $policy.class;
        }
      });
      this.findPolicyKey();
      let template: any;
      Object.keys(this.templateMap).forEach(($key: string) => {
        if ($key.toLocaleLowerCase() == `${(key as string).replace(/\s+|\./g, "").toLocaleLowerCase()}model`) {
          template = this.templateMap[$key];
        }
      })
      if (isSelected && template) {
        this.policyMatDialogRef = this._MatDialog.open(template, { panelClass, disableClose: true, autoFocus: false });
        if (!isEdit) {
          (this.policyCriteriaCopyForm.get('policyCriteria') as FormArray).at(policyIndex).get("value")?.setValue("");
        }
        if ([this.PolicyCriteriaTypes.Origin, this.PolicyCriteriaTypes.Destination].includes(key)) {
          const group = this.popupsForm.get(key.toLowerCase()) as FormGroup;
          if (!group) {
            return;
          }

          if (isEdit) {
            void this.hydrateOriginDestinationFromSaved(key);
          } else {
            group.reset();
            group.patchValue({ setFor: "Country", region: null, zone: null, inPolicy: "Allowed" });
            const resetFormArray = (arrayName: string, groupFactory: () => FormGroup) => {
              const formArray = group.get(arrayName) as FormArray;
              while (formArray.length > 0) {
                formArray.removeAt(0);
              }
              formArray.push(groupFactory());
            };
            resetFormArray('addCountry', this.anotherCountryGroup.bind(this));
            resetFormArray('addCity', this.anotherCityGroup.bind(this));
            resetFormArray('addAirport', this.anotherAirportGroup.bind(this));
            // Zone dropdown was removed from the UI; load country options immediately.
            this.getDropdowns('country', 0);
          }
        } else if (this.PolicyCriteriaTypes.Airline === key) {
          // For a fresh Airline selection, ensure nothing is pre-selected from previous popup usage.
          if (!isEdit) {
            this.commonApiLists.airlineCriteria?.forEach(($airline: any) => {
              $airline.isSelected = false;
              $airline.isVisible = true;
            });
            this.commonObj.tempAirlineLists = [];
            this.popupsForm.get("AirlineCriteria")?.setValue([]);
            (this.policyCriteriaCopyForm.get('policyCriteria') as FormArray)
              .at(policyIndex)
              .get("value")
              ?.setValue("");
          }

          let airline = this.policyCriteriaCopyForm.value.policyCriteria[this.commonObj.currentPopupIndex].value?.split(",") ?? "";
          if (airline?.length) {
            this.commonApiLists.airlineCriteria?.forEach(($airline: any) => {
              if (airline?.map(($tempAirline: any) => $tempAirline).includes($airline.AirlineCode)) {
                $airline.isSelected = true;
              }
            })
          }
          this.sortAirline();
        } else if (this.PolicyCriteriaTypes.LayoverDuration === key && isEdit) {
          this.popupsForm.get("Layover")?.patchValue({
            hh: this.policyCriteriaCopyForm.value.policyCriteria[this.commonObj.currentPopupIndex].value.split(" ")[0],
            mm: this.policyCriteriaCopyForm.value.policyCriteria[this.commonObj.currentPopupIndex].value.split(" ")[2]
          })
        } else if (this.PolicyCriteriaTypes.CostRange === key && isEdit) {
          let cost = this.policyCriteriaCopyForm.value.policyCriteria[this.commonObj.currentPopupIndex].value.split(" - ");
          this.popupsForm.get("costRange")?.patchValue({
            from: cost[0].replace(",", ""),
            to: cost[1].replace(",", "")
          })
        } else if (this.PolicyCriteriaTypes.BookingDate === key && isEdit) {
          let [from, to] = this.policyCriteriaCopyForm.value.policyCriteria[this.commonObj.currentPopupIndex].value.split("-")
          this.popupsForm.get("booking.from")?.setValue(this._CommonService.getFormattedDate(new Date(from.trim() || new Date())));
          this.popupsForm.get("booking.to")?.setValue(this._CommonService.getFormattedDate(new Date(to.trim() || new Date())));
        } else if (this.PolicyCriteriaTypes.TripDate === key && isEdit) {
          let [from, to] = this.policyCriteriaCopyForm.value.policyCriteria[this.commonObj.currentPopupIndex].value.split("-")
          this.popupsForm.get("trip.from")?.setValue(this._CommonService.getFormattedDate(new Date(from.trim() || new Date())));
          this.popupsForm.get("trip.to")?.setValue(this._CommonService.getFormattedDate(new Date(to.trim() || new Date())));
        } else if (this.PolicyCriteriaTypes.NumberOfStops === key && isEdit) {
          let value = this.policyCriteriaCopyForm.value.policyCriteria[this.commonObj.currentPopupIndex].value;
          let stop = this.commonApiLists.noOfStops.find(($stop: any) => $stop.bindLabel.toLowerCase() == (value.includes('stops') ? value.replace('ps', 'p') : value.toLowerCase()));
          this.popupsForm.get("NumberofStops")?.setValue(stop?.bindValue);
        }
      }
    }
  }
  remove(policy: any, index: number) {
    const policyArray = this.policyCriteriaCopyForm.get('policyCriteria') as FormArray;
    const isOnlyRow = policyArray?.length === 1;
    const isFirstRow = index === 0;

    // If deleting the first row and it's the only IF/AND row, just clear key/value instead of removing the row.
    if (isOnlyRow && isFirstRow) {
      const group = policyArray.at(index) as FormGroup | null;
      const key = group?.get('key')?.value;
      group?.patchValue({ key: null, value: null });

      this.commonApiLists.travelPolicyCriterial.forEach(($policy: any) => {
        if ($policy.name == key) {
          this.commonObj.popupType = $policy.name;
          $policy.isSelected = false;
          this.savePopup($policy.name, "", false);
        }
      });
      this.findPolicyKey();
      return;
    }

    policyArray.removeAt(index);
    this.commonApiLists.travelPolicyCriterial.forEach(($policy: any) => {
      if ($policy.name == policy.value.key) {
        this.commonObj.popupType = $policy.name;
        $policy.isSelected = false;
        this.savePopup($policy.name, "", false);
      }
    });
    this.findPolicyKey();
  }
  view(policy: any, index: number) {
    this.commonObj.viewTableHead = [];
    this.commonObj.viewTableRows = [];
    if ([this.PolicyCriteriaTypes.Origin, this.PolicyCriteriaTypes.Destination].includes(policy.key)) {
      const type = this.policyCriteriaForm[policy.key == this.PolicyCriteriaTypes.Origin ? 'OriginType' : 'DestinationType'];
      const rawCriteria = this.policyCriteriaForm[policy.key == this.PolicyCriteriaTypes.Origin ? 'Origin' : 'DestinationCriteria'];

      // Backend payload for City/Airport may contain tokens like "IN|DEL|BOM".
      // For view API we need only the last segment after "|".
      const normalizedCriteria = String(rawCriteria ?? '')
        .split(',')
        .map((t: string) => t.trim())
        .filter(Boolean)
        .map((t: string) => (t.includes('|') ? t.split('|').pop() : t))
        .join(',');

      this._CamService.getTravelerZoneCityAirportRegionCountry(String(type ?? '').toLowerCase(), normalizedCriteria).then(($: any) => {
        if (Object.values($?.data)?.length) {
          Object.entries($?.data).forEach(($: any) => {
            this.commonObj.viewTableRows.push({ AirlineCode: $[0], AirlineName: $[1] });
          })
        }
      })
    }
    switch (policy.key.toLowerCase()) {
      case "airline":
        this.policyMatDialogRef = this._MatDialog.open(this.ViewAirlineModel, { panelClass: "custom-popup-gen-market-type", disableClose: true, autoFocus: false });
        this.commonObj.viewTableHeading = this.PolicyCriteriaTypes.Airline;
        this.commonObj.viewTableHead = ['Key', 'Value'];
        const selectedCodes = (policy.value || '')
          .split(',')
          .map((code: string) => code.trim())
          .filter((code: string) => !!code);
        this.commonObj.viewTableRows = this.commonApiLists.airlineCriteria.filter(
          ($airline: any) => selectedCodes.includes(String($airline.AirlineCode).trim())
        );
        break;
      case "origin":
        this.policyMatDialogRef = this._MatDialog.open(this.ViewAirlineModel, { panelClass: "custom-popup-gen-market-type", disableClose: true, autoFocus: false });
        this.commonObj.viewTableHeading = this.PolicyCriteriaTypes.Origin;
        this.commonObj.viewTableHead = ['Key', 'Value'];
        break;
      case "destination":
        this.commonObj.viewTableHeading = this.PolicyCriteriaTypes.Destination;
        this.policyMatDialogRef = this._MatDialog.open(this.ViewAirlineModel, { panelClass: "custom-popup-gen-market-type", disableClose: true, autoFocus: false });
        this.commonObj.viewTableHead = ['Key', 'Value'];
        break;
    }
  }
  policyFilterShow(type: string): any[] {
    if (type == 'LIST') {
      return this.commonApiLists.travelPolicyCriterial.filter(($policy: any) => $policy.isSelected);
    }
    if (type == 'DROPDOWN') {
      return this.commonApiLists.travelPolicyCriterial.filter(($policy: any) => !$policy.isSelected);
    }
    else return [];
  }
  get policyCriteriaControls() {
    return (this.policyCriteriaCopyForm.get('policyCriteria') as FormArray).controls;
  }
  get isAddPolicyDisabled(): boolean {
    const policyArray = this.policyCriteriaCopyForm.get('policyCriteria') as FormArray | null;
    if (!policyArray || policyArray.length === 0) {
      return true;
    }
    const lastIndex = policyArray.length - 1;
    const lastGroup = policyArray.at(lastIndex) as FormGroup | null;
    const lastKey = lastGroup?.get('key')?.value;
    const lastValue = lastGroup?.get('value')?.value;
    const isLastIncomplete = !lastKey || !lastValue;
    return isLastIncomplete || policyArray.invalid;
  }
  searchAirlineFilter(event: any) {
    let str = event?.target?.value ?? event?.value ?? "";
    this.commonApiLists.airlineCriteria.forEach(($airline: any) => {
      if (!$airline.isSelected && $airline.AirlineName.toLocaleLowerCase().includes(str.trim().toLocaleLowerCase())) {
        $airline.isVisible = true;
      } else if ($airline.isSelected) {
        $airline.isVisible = true;
      } else {
        $airline.isVisible = false;
      }
    })
  }
  removeAddValidator(control: string, type: 'add' | 'remove') {
    this.popupsForm.get(control)?.[type == 'add' ? 'setValidators' : 'removeValidators']([Validators.required]);
    this.popupsForm.get(control)?.updateValueAndValidity();
  }
  showComponent(componentKey: string): void {
    this.isChildVisible[componentKey] = true;
    for (const key in this.isChildVisible) {
      if (key !== componentKey) {
        this.isChildVisible[key] = false;
      }
    }
    // this.selectedExpiryDate = this.dependentinfoForm?.get('prefLoyaltyPrograms.loyaltyExpiryDate')?.value;
  }
  DateTypeReturn(date: string): Date {
    return new Date(date);
  }
  onConfirm(componentKey: string) {
    this.hideComponent(componentKey);
  }
  hideComponent(componentKey: string): void {
    this.isChildVisible[componentKey] = false;
  }
  onDateSelected(event: any, component: string, controlParentName: string, controlChildName: string, isEdit: boolean = false): void {
    // if (event.isCalenderShow === true) {
    if (event.date.length == 2) {
      this.isChildVisible[component] = false;
      return;
    }
    if (!event?.date || event.date?.toDateString() === new Date(0)?.toDateString()) {
      return;
    }
    // this.selectedExpiryDate = event.date;
    const formattedDate = this._CommonService.getFormattedDate(event.date);
    this.popupsForm.get(`${controlParentName}.${controlChildName}`)?.setValue(formattedDate);
    if (controlChildName == 'from') {
      this.popupsForm.get(`${controlParentName}.to`)?.reset();
      this.popupsForm.get(`${controlParentName}`)?.updateValueAndValidity();
    }
    if (isEdit) {
      // this.EditLoyaltyProgram?.get('loyaltyExpiryDate')?.setValue(formattedDate);
    }
    this.isChildVisible[component] = false;
    // }
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const clickedElement = event.target as HTMLElement;
    const isClickInside = clickedElement.closest('mat-form-field') || clickedElement.closest('.datepicker-content-container');
    if (!isClickInside) {
      for (let [key, value] of Object.entries(this.isChildVisible)) {
        this.isChildVisible[key] = false;
      }
      this.removeAddValidator('booking.from', 'add');
      this.removeAddValidator('booking.to', 'add');
      this.removeAddValidator('trip.from', 'add');
      this.removeAddValidator('trip.to', 'add');
    }
  }
  airlineChange(airline: any) {
    airline.isSelected = !airline.isSelected;
    this.commonObj.tempAirlineLists.push(airline);
    this.sortAirline();
  }
  airlineSave(isRevert: boolean) {
    if (isRevert) {
      if (!!this.commonObj.tempAirlineLists.length) {
        this.commonApiLists.airlineCriteria?.forEach(($airline: any) => {
          if (this.commonObj.tempAirlineLists.map(($tempAirline: any) => $tempAirline.AirlineCode).includes($airline.AirlineCode)) {
            $airline.isSelected = !$airline.isSelected;
          }
        })
      }
    } else {
      this.popupsForm.get("AirlineCriteria")?.setValue(this.commonApiLists.airlineCriteria?.filter(($airline: any) => $airline.isSelected)?.map(($airline: any) => $airline.AirlineCode) ?? []);
    }
    this.commonObj.tempAirlineLists = [];
  }
  sortAirline() {
    this.commonApiLists.airlineCriteria.sort((a: any, b: any) => {
      const selectedDiff = Number(b.isSelected) - Number(a.isSelected);
      if (selectedDiff !== 0) return selectedDiff;
      return a.AirlineName.localeCompare(b.AirlineName);
    });
  }
  hasSelectedAirline(): boolean {
    return this.commonApiLists.airlineCriteria
      ? this.commonApiLists.airlineCriteria.some((airline: any) => airline.isSelected)
      : false;
  }

  saveForm() {
    this.formSetup();
    if (this.policyCriteriaCopyForm.valid) {
      this.commonObj.isSubmitting = true;
      let copy = JSON.parse(JSON.stringify(this._CommonService.removeNull(this.policyCriteriaForm)));
      if (!copy.OriginType) { delete copy.OriginType; delete copy.OriginCriteria; delete copy.OriginAllowed; }
      if (!copy.DestinationType) { delete copy.DestinationType; delete copy.DestinationCriteria; delete copy.DestinationAllowed; }
      if (!copy.BookingDateFrom) { delete copy.BookingDateFrom; delete copy.BookingDateTo; }
      if (!copy.TripDateFrom) { delete copy.TripDateFrom; delete copy.TripDateTo; }
      if (!copy.FareFromCriteria) { delete copy.FareFromCriteria; delete copy.FareToCriteria; }
      this._CamService.postCriteria(this.commonObj.id, copy).then(($: any) => {
         const isUpdate = this.policyCriteriaCopyForm.value.TravelPolicyId > 0;
        this._ToastrApiService.show('success', `Policy criteria has been ${ this.saveMode=='edit' ? 'updated':'saved'} successfully!`);
        this._PolicyManagementService.save_success('Policy criteria', 'Save')//GTM use
        this.commonObj.isSubmitting = false;
        this._Router.navigate(["/cam/policy-management/change-rule"], {
          queryParams: { enc: this._CryptoService.encryptData({ policyID: $?.data?.policyId }) }
        })
      }).catch((error: any) => {
        const message =
          error?.error?.message ||
          error?.message ||
          'Something went wrong. Please try again.';
          this._PolicyManagementService.view_error_message(message,error?.code);
      })
    }

    this._PolicyManagementService.policy_criteria_save('Policy Criteria', 'Save', this.policyCriteriaCopyForm.value, this.policyName)
  }
  formSetup() {
    let formVal = JSON.parse(JSON.stringify(this.policyCriteriaCopyForm.value));
    if (formVal.jouneryRule.OW || formVal.jouneryRule.RT || formVal.jouneryRule.MCT) {
      if (formVal.jouneryRule.OW) {
        this.policyCriteriaForm.JourneyOWInbound = true;
        this.policyCriteriaForm.JourneyOWOutbound = true;
      }
      if (formVal.jouneryRule.RT) {
        this.policyCriteriaForm.JourneyRTInbound = true;
        this.policyCriteriaForm.JourneyRTOutbound = true;
      }
      if (formVal.jouneryRule.MCT) {
        this.policyCriteriaForm.JourneyMultiDestination = true;
      }
    } else {
      this.policyCriteriaForm.JourneyOWInbound = false;
      this.policyCriteriaForm.JourneyOWOutbound = false;
      this.policyCriteriaForm.JourneyRTInbound = false;
      this.policyCriteriaForm.JourneyRTOutbound = false;
      this.policyCriteriaForm.JourneyMultiDestination = false;
    }
    if (!!formVal.outPolicyReasion) this.policyCriteriaForm.OutPolicyReasion = (formVal.outPolicyReasion);
    if (!!formVal.maxTripStayDays) this.policyCriteriaForm.MaxTripStayDays = (formVal.maxTripStayDays);
    if (!!formVal.beforeTripStart) this.policyCriteriaForm.BeforeTripStart = (formVal.beforeTripStart);
    if (!this.isZeroOrEmpty(formVal.fareToleranceDomestic)) this.policyCriteriaForm.FareToleranceDom = (formVal.fareToleranceDomestic);
    if (formVal.fareToleranceDomesticPercentage) this.policyCriteriaForm.FareToleranceTypeDom = (formVal.fareToleranceDomesticPercentage ? "P" : "F");
    if (!this.isZeroOrEmpty(formVal.fareToleranceInternational)) this.policyCriteriaForm.FareTolerance = (formVal.fareToleranceInternational);
    if (formVal.fareToleranceInternationalPercentage) this.policyCriteriaForm.FareToleranceType = (formVal.fareToleranceInternationalPercentage ? "P" : "F");
    if (formVal.nonRefundable) this.policyCriteriaForm.NonRefundable = (formVal.nonRefundable);
    this.policyCriteriaForm.IsEconomy = formVal.IsEconomy;
    this.policyCriteriaForm.IsBusiness = formVal.IsBusiness;
    this.policyCriteriaForm.IsFirst = formVal.IsFirst;
  }
  savePopup(popupType: string, value: any, isReset: boolean = true, isHTML: boolean = true) {
    if (['MarketTypeModel', "Market type"].includes(popupType)) {
      if (isReset) {
        (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("value")?.setValue(value == "DOM" || value === 'Domestic' ? 'Domestic' : "International");
        this.policyCriteriaForm.MarketType = value;
      } else {
        this.policyCriteriaForm.MarketType = value;
        this.popupsForm.get("MarketType")?.setValue("DOM");
      }
    } else if (["AirlineModel", this.PolicyCriteriaTypes.Airline].includes(popupType)) {
      if (isReset) {
        (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("value")?.setValue(value?.join(",") ?? "");
        this.policyCriteriaForm.Air = (value?.join(",") ?? "");
      } else {
        this.popupsForm.get("AirlineCriteria")?.reset("");
        this.policyCriteriaForm.Air = value;
      }
    } else if (["CostRangeModel", this.PolicyCriteriaTypes.CostRange].includes(popupType)) {
      if (+value.to < +value.from) {
        this._ToastrApiService.show("error", "From Cost Range Should not be greater than from To Cost Range");
        return;
      }
      if (isReset) {
        (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("value")?.setValue(`${Number(value.from).toLocaleString('en-IN')} - ${Number(value.to).toLocaleString('en-IN')}`);
        this.policyCriteriaForm.FareFromCriteria = value.from;
        this.policyCriteriaForm.FareToCriteria = value.to;
      } else {
        this.policyCriteriaForm.FareFromCriteria = value;
        this.policyCriteriaForm.FareToCriteria = value;
        this.popupsForm.get("costRange")?.reset({ from: "", to: "", });
      }
    } else if (["BookingDateModel", this.PolicyCriteriaTypes.BookingDate].includes(popupType)) {
      if (isReset) {
        let from: string = this._DatePipe.transform(this._CommonService.postFormatDate(value.from), "dd MMM yyyy") ?? "";
        let to: string = this._DatePipe.transform(this._CommonService.postFormatDate(value.to), "dd MMM yyyy") ?? "";
        (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("value")?.setValue(`${from} - ${to}`);
        this.policyCriteriaForm.BookingDateFrom = this._CommonService.postFormatDate(value.from);
        this.policyCriteriaForm.BookingDateTo = this._CommonService.postFormatDate(value.to);
      } else {
        this.policyCriteriaForm.BookingDateFrom = value;
        this.policyCriteriaForm.BookingDateTo = value;
        this.popupsForm.get("booking")?.reset({ from: this._CommonService.getFormattedDate(new Date()), to: "", });
      }
    } else if (["TripDateModel", this.PolicyCriteriaTypes.TripDate].includes(popupType)) {
      if (isReset) {
        let from: string = this._DatePipe.transform(this._CommonService.postFormatDate(value.from), "dd MMM yyyy") ?? "";
        let to: string = this._DatePipe.transform(this._CommonService.postFormatDate(value.to), "dd MMM yyyy") ?? "";
        (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("value")?.setValue(`${from} - ${to}`);
        this.policyCriteriaForm.TripDateFrom = this._CommonService.postFormatDate(value.from);
        this.policyCriteriaForm.TripDateTo = this._CommonService.postFormatDate(value.to);
      } else {
        this.policyCriteriaForm.TripDateFrom = value;
        this.policyCriteriaForm.TripDateTo = value;
        this.popupsForm.get("trip")?.reset({ from: this._CommonService.getFormattedDate(new Date()), to: "", });
      }
    } else if (["NoOfStopsModel", this.PolicyCriteriaTypes.NumberOfStops].includes(popupType)) {
      if (isReset) {
        (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("value")?.setValue(value.toLowerCase() == '0' ? "Direct" : `${value} ${this._CommonService.returnQuantityS(value, "stop")}`);
        this.policyCriteriaForm.NumberOfStops = value;
      } else {
        this.policyCriteriaForm.NumberOfStops = value;
        this.popupsForm.get("NumberofStops")?.setValue("0");
      }
    } else if (["LayoverDurationModel", this.PolicyCriteriaTypes.LayoverDuration].includes(popupType)) {
      if (isReset) {
        let let_hr = value.hh < 10 ? value.hh.includes('0') ? value.hh : ("0" + value.hh) : value.hh;
        let let_mm = value.mm < 10 ? value.mm.includes('0') ? value.mm : ("0" + value.mm) : value.mm;
        (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("value")?.setValue(`${let_hr} hrs ${let_mm} mins`);
        this.policyCriteriaForm.LayoverDuration = `${let_hr}:${let_mm}`;
      } else {
        this.policyCriteriaForm.LayoverDuration = "";
        this.popupsForm.get("Layover")?.reset({ hh: "", mm: "", })
      }
    } else if (["OriginModel", "DestinationModel", this.PolicyCriteriaTypes.Origin, this.PolicyCriteriaTypes.Destination].includes(popupType)) {
      if (isReset) {
        (this.policyCriteriaForm as any)[[this.getPType().c] + "Type"] = this.popupsForm.value[this.getPType().p].setFor;
        (this.policyCriteriaForm as any)[[this.getPType().c] + "Allowed"] = this.popupsForm.value[this.getPType().p].inPolicy?.toLowerCase() === 'allowed';
        switch (this.popupsForm.value[this.getPType().p].setFor.toLowerCase()) {
          case "region":
            (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("value")?.setValue(`${value.inPolicy}/${value.region?.join(",")}`);
            (this.policyCriteriaForm as any)[this.getPType().k] = this.popupsForm.value[this.getPType().p].region.join(",");
            break;
          case "zone":
            (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("value")?.setValue(`${value.inPolicy}/${value.zone?.map((z: string) => `Zone ${z}`).join(', ')}`);
            (this.policyCriteriaForm as any)[this.getPType().k] = this.popupsForm.value[this.getPType().p].zone.join(",");
            break;
          case "country":
            (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("value")?.setValue(`${value.inPolicy}/${[...new Set((isHTML ? value.zone : value.addCountry).map(($country: any) => (isHTML ? $country : $country.country)))].join(",")}`);
            (this.policyCriteriaForm as any)[this.getPType().k] = [...new Set((isHTML ? value.zone : value.addCountry).map(($country: any) => (isHTML ? $country : $country.country)))].join(",");
            break;
          case "city":
            {
              const addCity = Array.isArray(value.addCity) ? value.addCity : [];
              const cityCodes: string[] = [];
              const encoded: string[] = [];

              addCity.forEach((grp: any) => {
                const countryCode = grp?.country;
                const cities: string[] = Array.isArray(grp?.city) ? grp.city : (grp?.city ? [grp.city] : []);
                cities.forEach((c: any) => {
                  const city = String(c)?.trim();
                  if (!city) return;
                  cityCodes.push(city);
                  if (countryCode) {
                    encoded.push(`${String(countryCode).trim()}|${city}`);
                  }
                });
              });

              const uniqueCityCodes = [...new Set(cityCodes)];
              const uniqueEncoded = [...new Set(encoded)];

              // Display keeps only last segment (city code).
              (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("value")?.setValue(`${value.inPolicy}/${uniqueCityCodes.join(",")}`);

              // Saved criteria keeps country|city. If country info missing, fallback to old format.
              (this.policyCriteriaForm as any)[this.getPType().k] = uniqueEncoded.length ? uniqueEncoded.join(",") : uniqueCityCodes.join(",");
            }
            break;
          case "airport":
            {
              const addAirport = Array.isArray(value.addAirport) ? value.addAirport : [];
              const airportCodes: string[] = [];
              const encoded: string[] = [];

              addAirport.forEach((grp: any, rowIndex: number) => {
                const countryCode = grp?.country;
                const selectedCities: string[] = Array.isArray(grp?.city) ? grp.city : (grp?.city ? [grp.city] : []);
                const selectedAirports: string[] = Array.isArray(grp?.airport) ? grp.airport : (grp?.airport ? [grp.airport] : []);
                const country = countryCode ? String(countryCode).trim() : '';

                // Try to resolve CityCode for each AirportCode from loaded dropdown items.
                const airportDropdown = (this.commonApiLists.dropdowns as any)?.[this.getPType().p + "Airport"]?.[rowIndex]?.all ?? [];
                const airportToCity: Record<string, string> = {};
                airportDropdown?.forEach((it: any) => {
                  const ap = it?.AirportCode ?? it?.airportCode;
                  const city = it?.CityCode ?? it?.cityCode;
                  if (ap && city) airportToCity[String(ap)] = String(city);
                });

                selectedAirports.forEach((ap: any) => {
                  const airportCode = String(ap)?.trim();
                  if (!airportCode) return;
                  airportCodes.push(airportCode);

                  const mappedCity = airportToCity[airportCode] ? String(airportToCity[airportCode]).trim() : "";
                  if (!country) return;

                  if (mappedCity) {
                    encoded.push(`${country}|${mappedCity}|${airportCode}`);
                  } else if (selectedCities?.length) {
                  // If airport->city mapping isn't available, avoid cross-product.
                  // Heuristic: city code may equal airport code for common mappings (e.g. DEL/BOM).
                  const exactCity = selectedCities
                    .map((c: any) => String(c).trim())
                    .find((c: string) => c === airportCode);
                  const cityForAirport = exactCity || String(selectedCities[0] ?? '').trim();
                  if (cityForAirport) {
                    encoded.push(`${country}|${cityForAirport}|${airportCode}`);
                  }
                  }
                });

                // Persist cities selected without an airport so edit/reload keeps all city chips.
                selectedCities.forEach((cityCode: any) => {
                  const city = String(cityCode).trim();
                  if (!city || !country) return;
                  const alreadySaved = encoded.some((entry: string) => {
                    const parts = entry.split('|').map((p: string) => p.trim());
                    return parts.length >= 2 && parts[1] === city;
                  });
                  if (!alreadySaved) {
                    encoded.push(`${country}|${city}`);
                  }
                });
              });

              const uniqueAirportCodes = [...new Set(airportCodes)];
              const uniqueEncoded = [...new Set(encoded)];

              // Display keeps only last segment (airport code).
              (this.policyCriteriaCopyForm.get("policyCriteria") as FormArray).at(this.commonObj.currentPopupIndex).get("value")?.setValue(`${value.inPolicy}/${uniqueAirportCodes.join(",")}`);

              // Saved criteria keeps country|city|airport. If country/city info missing, fallback.
              (this.policyCriteriaForm as any)[this.getPType().k] = uniqueEncoded.length ? uniqueEncoded.join(",") : uniqueAirportCodes.join(",");
            }
            break;
        }
        if ([this.PolicyCriteriaTypes.Origin, this.PolicyCriteriaTypes.Destination].includes(this.commonObj.popupType)) {
          void this.hydrateOriginDestinationFromSaved(this.commonObj.popupType);
        }
      } else {
        (this.policyCriteriaForm as any)[[this.getPType().c] + "Type"] = value;
        (this.policyCriteriaForm as any)[[this.getPType().c] + "Allowed"] = value;
        (this.policyCriteriaForm as any)[this.getPType().k] = value;
      }
    }
    this.policyMatDialogRef?.close();
  }
  onCriteriaPopupClose(): void {
    const index = this.commonObj.currentPopupIndex;
    const isEdit = (this.commonObj as any).isEditPopup;
    const policyArray = this.policyCriteriaCopyForm.get('policyCriteria') as FormArray | null;

    if (isEdit && [this.PolicyCriteriaTypes.Origin, this.PolicyCriteriaTypes.Destination].includes(this.commonObj.popupType)) {
      void this.hydrateOriginDestinationFromSaved(this.commonObj.popupType);
    }

    if (!isEdit && policyArray !== null && index !== null && index !== undefined && index >= 0 && index < policyArray.length) {
      const group = policyArray.at(index) as FormGroup;
      const key = group.get('key')?.value;

      if (key) {
        group.patchValue({ key: null, value: null });
        this.commonApiLists.travelPolicyCriterial.forEach(($policy: any) => {
          if ($policy.name === key) {
            $policy.isSelected = false;
          }
        });
        this.findPolicyKey();
      }
    }

    this.policyMatDialogRef?.close();
  }
  resetOriginDestination(type: PolicyCriteriaTypes) {
    const groupKey = type === this.PolicyCriteriaTypes.Origin ? 'origin' : 'destination';
    const group = this.popupsForm.get(groupKey) as FormGroup | null;
    if (!group) {
      return;
    }
    group.reset();
    group.patchValue({
      setFor: 'Country',
      region: null,
      zone: null,
      inPolicy: 'Allowed'
    });
    const resetFormArray = (arrayName: string, factory: () => FormGroup) => {
      const formArray = group.get(arrayName) as FormArray;
      if (!formArray) {
        return;
      }
      while (formArray.length > 0) {
        formArray.removeAt(0);
      }
      formArray.push(factory());
    };
    resetFormArray('addCountry', this.anotherCountryGroup.bind(this));
    resetFormArray('addCity', this.anotherCityGroup.bind(this));
    resetFormArray('addAirport', this.anotherAirportGroup.bind(this));
    Object.keys(this.commonApiLists.dropdowns)
      .filter(key => key.startsWith(groupKey))
      .forEach(key => {
        this.commonApiLists.dropdowns[key] = [{ pipe: [], all: [] }];
      });

    // Zone dropdown was removed; load country options immediately.
    this.getDropdowns('country', 0);
  }
  reset(type: PolicyCriteriaTypes) {
    if ([PolicyCriteriaTypes.Origin, this.PolicyCriteriaTypes.Destination].includes(type)) {
      this.popupsForm.get(this.getPType().p)?.get(this.commonApiLists.originSetForController[this.popupsForm.value[this.getPType().p].setFor])?.reset();
      this.popupsForm.get(this.getPType().p)?.get("inPolicy")?.setValue("Allowed");
      for (let [key, value] of Object.entries(this.commonApiLists.dropdowns)) {
        this.commonApiLists.dropdowns[key]?.forEach(($prop: Object, $propIndex: number) => {
          this.commonApiLists.dropdowns[key][$propIndex] = [{ pipe: [], all: [] }];
        })
      }

      // Zone selection UI removed: load country options directly based on selected "setFor".
      const p = this.getPType().p;
      const setFor = (this.popupsForm.value[p]?.setFor ?? '').toLowerCase();
      if (setFor === 'country') {
        const addCountry = this.popupsForm.get(`${p}.addCountry`) as FormArray;
        addCountry?.controls?.forEach((_, idx) => this.getDropdowns('country', idx));
      } else if (setFor === 'city') {
        const addCity = this.popupsForm.get(`${p}.addCity`) as FormArray;
        addCity?.controls?.forEach((_, idx) => this.getDropdowns('city', idx));
      } else if (setFor === 'airport') {
        const addAirport = this.popupsForm.get(`${p}.addAirport`) as FormArray;
        addAirport?.controls?.forEach((_, idx) => this.getDropdowns('airport', idx));
      }
    } else if (this.PolicyCriteriaTypes.CostRange == type) {
      this.popupsForm.get("costRange")?.reset({ from: "", to: "" });
    } else if (this.PolicyCriteriaTypes.LayoverDuration == type) {
      this.popupsForm.get("Layover")?.reset({ hh: "", mm: "" });
    }
  }
  navigateToList() {
    this._PolicyManagementService.policy_criteria_Cancel('Policy Criteria Page', 'Cancel')//GTM use
    this._CamService.resetPolicyFormsMode();
    this._Router.navigate(["cam", "policy-management"]);
    
  }
  isViewVisible(key: string): boolean {
    const rows = this.policyCriteriaCopyForm?.value?.policyCriteria || [];

    if (key === this.PolicyCriteriaTypes.Airline) {
      const airlineRow = rows.find(
        (r: any) => r?.key === this.PolicyCriteriaTypes.Airline
      );
      return !!(airlineRow && airlineRow.value && String(airlineRow.value).trim().length);
    }

    if ([this.PolicyCriteriaTypes.Origin, this.PolicyCriteriaTypes.Destination].includes(key as any)) {
      const row = rows.find((r: any) => r?.key === key);
      return !!(row && row.value && String(row.value).trim().length);
    }

    return false;
  }
  commonApiUniqueLists(type: string, index: number, controls: any[], drop: string) {
    if (type === "check_country") {
      let lists: any[] = controls;
      let valLists: any[] = lists.map(($list: any) => $list.country).flat();
      let lLists: any[] = this.commonApiLists.dropdowns[drop];
      if (!lists.length) {
        this.commonApiLists[type].lists = lists;
      }
      this.commonApiLists[type].isAdd = this.commonApiLists[type].lists.length <= lists.length;
      lLists.forEach(($list: any, $listIndex: number) => {
        if (this.commonApiLists[type].isAdd && $listIndex !== index) {
          let includeLists: string[] = valLists?.filter(($valOnly: any) => !!$valOnly);
          includeLists = includeLists.filter(($fil: string) => !controls[$listIndex].country.includes($fil));
          $list.pipe = $list.all.filter(($inList: any) => !includeLists.includes($inList.CountryCode));
        } else if (!this.commonApiLists[type].isAdd) {
          let includeLists: string[] = lists[index]?.country?.filter(($valOnly: any) => !!$valOnly);
          if ($list.pipe.length === $list.all.length) {
            $list.pipe = $list.all;
          } else {
            $list.pipe = $list.all.filter(($inList: any) => !includeLists.includes($inList.CountryCode));
          }
        }
      })
      if (!!lists.length) {
        this.commonApiLists[type].lists = lists;
      }
    } else if (type === "check_city") {
      let lists: any[] = controls;
      let valLists: any[] = lists.map(($list: any) => $list.city).flat();
      let lLists: any[] = this.commonApiLists.dropdowns[drop];
      if (!lists.length) {
        this.commonApiLists[type].lists = lists;
      }
      this.commonApiLists[type].isAdd = this.commonApiLists[type].lists.length <= lists.length;
      lLists.forEach(($list: any, $listIndex: number) => {
        if (this.commonApiLists[type].isAdd && $listIndex !== index) {
          let includeLists: string[] = valLists?.filter(($valOnly: any) => !!$valOnly);
          includeLists = includeLists.filter(($fil: string) => !controls[$listIndex].city.includes($fil));
          $list.pipe = $list.all.filter(($inList: any) => !includeLists.includes($inList.CityCode));
        } else if (!this.commonApiLists[type].isAdd) {
          let includeLists: string[] = Array.isArray(lists[index]?.city)
            ? lists[index].city.filter(($valOnly: any) => !!$valOnly)
            : [];
          if ($list.pipe.length === $list.all.length) {
            $list.pipe = $list.all;
          } else {
            $list.pipe = $list.all.filter(($inList: any) => !includeLists.includes($inList.CityCode));
          }
        }
      })
      if (!!lists.length) {
        this.commonApiLists[type].lists = lists;
      }
      const selectedCities = Array.isArray(lists[index]?.city) ? lists[index].city : [];
      this.mergeSelectedOptionsIntoPipe(drop, index, selectedCities, 'CityCode');
    } else if (type === "check_airport") {
      let lists: any[] = controls;
      let valLists: any[] = lists.map(($list: any) => $list.airport).flat();
      let lLists: any[] = this.commonApiLists.dropdowns[drop];
      if (!lists.length) {
        this.commonApiLists[type].lists = lists;
      }
      this.commonApiLists[type].isAdd = this.commonApiLists[type].lists.length <= lists.length;
      lLists.forEach(($list: any, $listIndex: number) => {
        if (this.commonApiLists[type].isAdd && $listIndex !== index) {
          let includeLists: string[] = valLists?.filter(($valOnly: any) => !!$valOnly);
          includeLists = includeLists.filter(($fil: string) => !controls[$listIndex].airport.includes($fil));
          $list.pipe = $list.all.filter(($inList: any) => !includeLists.includes($inList.AirportCode));
        } else if (!this.commonApiLists[type].isAdd) {
          let includeLists: string[] = lists[index]?.city?.filter(($valOnly: any) => !!$valOnly);
          if ($list.pipe.length === $list.all.length) {
            $list.pipe = $list.all;
          } else {
            $list.pipe = $list.all.filter(($inList: any) => !includeLists.includes($inList.AirportCode));
          }
        }
      })
      if (!!lists.length) {
        this.commonApiLists[type].lists = lists;
      }
      const selectedAirports = Array.isArray(lists[index]?.airport) ? lists[index].airport : [];
      this.mergeSelectedOptionsIntoPipe(drop, index, selectedAirports, 'AirportCode');
    }
  }
  getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((o, k) => (o ? o[k] : undefined), obj);
  }
  atLeastOneCheckboxCheckedValidator(): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const controls = (formGroup as FormGroup).controls;
      const isAnyChecked = Object.values(controls).some(control => control.value === true);
      return isAnyChecked ? null : { atLeastOneRequired: true };
    };
  }

  private bothOrNoneFilledValidator(keyControlName: string, valueControlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const group = control as FormGroup;
      const keyVal = group.get(keyControlName)?.value;
      const valueVal = group.get(valueControlName)?.value;

      const isEmpty = (v: any): boolean => {
        if (v === null || v === undefined) return true;
        if (typeof v === 'string') return v.trim().length === 0;
        if (Array.isArray(v)) return v.length === 0;
        if (v instanceof Date) return Number.isNaN(v.getTime());
        if (typeof v === 'object') return Object.keys(v).length === 0;
        return false;
      };

      const hasKey = !isEmpty(keyVal);
      const hasValue = !isEmpty(valueVal);

      // valid when both empty OR both filled
      if (hasKey === hasValue) return null;
      return { keyValuePairRequired: true };
    };
  }

  outOfPolicyReasonBlockInvalid(event: KeyboardEvent): void {
    const allowedRegex = /^[a-zA-Z0-9.,\-()'\/&@ ]$/;
    if (!allowedRegex.test(event.key)) {
      event.preventDefault();
    }
  }

  validateDays(event: KeyboardEvent, controlName: string): void {
    if (!/^\d$/.test(event.key)) return event.preventDefault();

    const ctrl = this.policyCriteriaCopyForm.get(controlName);
    if (!ctrl) return;

    const val = Number((ctrl.value ?? '') + event.key);

    if (val < 1) {
      ctrl.setErrors({ minlength: true });
      return event.preventDefault();
    }
    if (val > 365) {
      ctrl.setErrors({ maxlength: true });
      return event.preventDefault();
    }

    // ✅ Clear errors when value is valid
    ctrl.setErrors(null);
  }

  fareTollaranceValidation(event: KeyboardEvent) {
    const allowedRegex = /^[0-9]+$/
    if (!allowedRegex.test(event.key)) {
      return event.preventDefault();
    }
  }
ngOnDestroy(){
  this.destroy$.next();
  this.destroy$.complete();
}
}
